import React from 'react';

const Modal = ({ isOpen, onClose, title, children }) => {
    React.useEffect(() => {
        if (isOpen) {
            // Get scrollbar width before hiding it
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            
            // Hide scrollbar and add padding to compensate
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = `${scrollbarWidth}px`;
        } else {
            // Restore original state
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        }
        
        // Cleanup function
        return () => {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 bg-black/20 backdrop-blur-sm z-50 flex justify-center items-center"
            onClick={onClose} // Close modal when clicking backdrop
        >
            <div
                className="bg-white w-full max-w-3xl rounded-xl shadow-xl p-6 relative"
                onClick={e => e.stopPropagation()} // Prevent close when clicking inside modal
            >
                <button
                    onClick={onClose}
                    className="absolute top-2 right-2 text-xl text-gray-600 hover:text-black"
                >
                    &times;
                </button>
                {title && <h2 className="text-xl font-semibold mb-4">{title}</h2>}
                <div className="max-h-[70vh] overflow-y-auto">{children}</div>
            </div>
        </div>
    );
};

export default Modal;
